module.exports = __webpack_public_path__ + "media/freesound_community-vibrating-message-37619.7c0b2fcf.mp3";